/*
 * @Author: 谢树和 shuhe.xie@southgis.com
 * @Date: 2022-10-12 15:16:57
 * @LastEditors: 谢树和 shuhe.xie@southgis.com
 * @LastEditTime: 2022-10-25 14:52:33
 * @FilePath: \standard-v5\src\store\modules\opinion.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const state = {
  opinionData: {},
  rid: null
}

const getters = {
  getOpinionData: state => index => {
    return index ? state.opinionData[index] : state.opinionData
  }
}

const mutations = {
  setOpinionData(state, data) {
    state.opinionData = data
  },
  setRid(state,data){
    state.rid= data
  },
}
const actions = {}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
